import {of, throwError} from 'rxjs';
import {fromPromise} from 'rxjs/internal-compatibility';
import {catchError, map, mergeMap, retryWhen} from 'rxjs/operators';
import {BI_ERRORS} from '../biErrorLogger/biErrors';
import {errorLogger} from '../errorLogger/errorLogger';
import {normalizeDownloadLinks} from '../utils/normalizeDownloadLinks/normalizeDownloadLinks';
import {genericRetryStrategy} from '../utils/rxjs/genericRetryStrategy/genericRetryStrategy';
import {dgsRequest} from './dgsRequest';

export const fetchDownloadLinks = (params: {
  instance: string;
  paymentsId: string | null;
  sToken: string;
  ref: string;
  albumId: string;
  trackId?: number;
}) => {
  return of(params)
    .pipe(
      mergeMap(({instance, paymentsId, sToken, ref, albumId, trackId}) =>
        fromPromise(dgsRequest({instance, paymentsId, sToken, ref, albumId, trackId})),
      ),
      retryWhen(genericRetryStrategy({maxRetryAttempts: 3})),
      catchError((reason) => {
        errorLogger.logError({bi: BI_ERRORS.getWindow.dgs.freeDownloadLinks}, {reason});
        return throwError(reason);
      }),
      map(normalizeDownloadLinks),
    )
    .toPromise();
};
